import React, { useState } from "react";
import { Modal } from "flowbite-react";
import JobAlertWindow from "./JobAlertWindow";

function JobAlertModal({ show, onClose }) {
  const [key, setKey] = useState(Date.now());

  // This function can be called whenever you want to reset the key
  const resetKey = () => {
    setKey(Date.now());
  };

  return (
    <Modal onClose={onClose} show={show}>
      <div className="w-600px">
        <Modal.Header> 🔔 Get Daily Job Alert</Modal.Header>
        <Modal.Body>
          <div className="space-y-8">
            <div
              className="relative overflow-x-auto shadow-md sm:rounded-lg"
              style={{ overflowY: "auto", maxHeight: "300px" }}
            ></div>
          </div>
          <JobAlertWindow key={key} />
        </Modal.Body>
      </div>
    </Modal>
  );
}

export default JobAlertModal;
